module.exports = __webpack_public_path__ + "img/logo.e11dbd56.png";